import { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { userService } from "../../../services/CommonServices";
import GlobalContext from "../../../context/GlobalContext";
import { CSVLink, CSVDownload } from "react-csv";
import { downloadExcel } from "react-export-table-to-excel";
import ReactPaginate from 'react-paginate';
import * as XLSX from "xlsx";
import Loader from '../../Loader/Loader';

const PatientConsultationNotesList=(props)=>{
    
    let navigate = useNavigate();
    const location = useLocation();
    var globalData=useContext(GlobalContext)
    const[res,setRes]=useState([])
    const[resAll,setResAll]=useState([])
    const[page,setPage]=useState(0)

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const [isLoading, setIsLoading] = useState(true);

    const handleStartDateChange = (event) => {
      // Update the state with the new input value
      setStartDate(event.target.value);
    };
    
    const handleEndDateChange = (event) => {
      // Update the state with the new input value
      setEndDate(event.target.value);
    };

    const clearSearchedFeilds = (event) => {
      setStartDate('');
      setEndDate('');
      setRes(resAll);
    };

    function performSearch(event) {
      event.preventDefault();
      if(startDate == '' || startDate == undefined || startDate == null) {
        alert("Kindly select start date.");
        return;
      }
      if(endDate == '' || endDate == undefined || endDate == null) {
        alert("Kindly select end date.");
        return;
      }
      var temp = [];
      for(var i = 0; i < resAll.length; i++) {
        var age = new Date(resAll[i].createdTs);
        var startDate2 = new Date(startDate);
        var endDate2 = new Date(endDate);
        startDate2.setHours(0);
        startDate2.setMinutes(0);
        startDate2.setSeconds(0);
        endDate2.setHours(23);
        endDate2.setMinutes(59);
        endDate2.setSeconds(59);
        if(age.getTime() >= startDate2.getTime() && age.getTime() <= endDate2.getTime()) {
          temp.push(resAll[i]);
        }
      }
      setRes(temp);
    }

    useEffect(()=>{
        get_consultation_notes_list(page);
    },[])
    
    function get_consultation_notes_list(page_temp) {
      const queryParams = new URLSearchParams(location.search);
      const patientId = queryParams.get('patientId');
        const headers = {
            "Authorization" : globalData.token
        }
        userService.patient_consultation_notes_list_api(patientId, headers, page_temp, 50).then(response=>{
            if(response.status==200){
                for(var i = 0; i < response.data.consultationLogDTOS.content.length; i++) {
                  var date = new Date(response.data.consultationLogDTOS.content[i].createdTs);
                  var year = date.getFullYear();
                  var month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based, so we add 1
                  var day = date.getDate().toString().padStart(2, '0');
                  var hours = date.getHours().toString().padStart(2, '0');
                  var minutes = date.getMinutes().toString().padStart(2, '0');
                  var seconds = date.getSeconds().toString().padStart(2, '0');
                  response.data.consultationLogDTOS.content[i].createdTs = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                }
                setRes(res => [...res, ...response.data.consultationLogDTOS.content]);
                setResAll(resAll => [...resAll, ...response.data.consultationLogDTOS.content]);
                if(response.data.consultationLogDTOS.content.length == 50) {
                  setPage(page_temp + 1);
                  get_consultation_notes_list(page_temp + 1);
                } else {
                  setIsLoading(false);
                }
            }
        }).catch(error => {
          setIsLoading(false);
            if(error.response.status == 401) {
              globalData.set_token("")
              globalData.set_org_id("")
              sessionStorage.removeItem('token')
              sessionStorage.removeItem('org_id')
              //location.reload(true);
              navigate('/login')
            }
        });
    }

    function Items({ currentItems }) {
        return (
          <>
            {currentItems &&
              currentItems.map((item) => (
                <tr>
                    <td>{item.id}</td>
                    <td>{item.uuid}</td>
                    <td>{item.status}</td>
                    <td>{item.startTime}</td>
                    <td>{item.consultationTime}</td>
                    <td>{item.type}</td>
                    <td>{item.publishStatus}</td>
                    <td>{item.reason}</td>
                    <td>{item.dateCreatedTimezone}</td>
                    <td>{item.timezone}</td>                    
                    <td>{item.createdTs}</td>
                    <td>{item.dateCreated}</td>                    
                    <td>{item.lastUpdated}</td>
                    <td>{item.pdfLink}</td>                                                                                                                        
                    <td>{item.typeId}</td>                    
                </tr>
              ))}
          </>
        );
    }


    function PaginatedItems({ itemsPerPage }) {
        const [itemOffset, setItemOffset] = useState(0);
    
        const endOffset = itemOffset + itemsPerPage;
        console.log(`Loading items from ${itemOffset} to ${endOffset}`);
        const currentItems = res.slice(itemOffset, endOffset);
        const pageCount = Math.ceil(res.length / itemsPerPage);
    
        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % res.length;
        console.log(
            `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setItemOffset(newOffset);
        };
    
        return (
        <>
            <Items currentItems={currentItems} />
            <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            />
        </>
        );
    }
    
      const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(res);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
        XLSX.writeFile(wb, "exported_data.xlsx");
      };
  
return(

            <div class="content_area">
                        <div>
                          {isLoading && (
                            <Loader /> // Render the loader component while loading
                          )}
                        </div>
                        <div class="tables_area">
                        <div class="title-box">

                            <h2 class="pull-left">Consulation Notes List</h2>
                            <CSVLink data={res} className="blue_btn yellow_btn pull-right text-uppercase">Download CSV</CSVLink>
                            <a onClick={exportToExcel} class="blue_btn yellow_btn pull-right text-uppercase">Download excel</a>&nbsp;
                            <div class="clear"></div>
                            </div>
                            <div class="filter-box">
                            Created Ts : 
                            <input type="date" value={startDate} onChange={handleStartDateChange} />
                            <input type="date" value={endDate} onChange={handleEndDateChange} />
                            <a onClick={performSearch} class="blue_btn yellow_btn text-uppercase">Search</a>
                            <a onClick={clearSearchedFeilds} class="blue_btn yellow_btn text-uppercase">Clear</a>
                            </div>
                            <div class="white_box">
                                <div class="table-responsive">
                                    <table width="100%" cellspacing="0" cellpadding="0">
                                        <thead>
                                            <tr>
                                              <th>id</th>
                                              <th>uuid</th>
                                              <th>status</th>
                                              <th>startTime</th>
                                              <th>consultationTime</th>
                                              <th>type</th>
                                              <th>publishStatus</th>
                                              <th>reason</th>
                                              <th>dateCreatedTimezone</th>
                                              <th>timezone</th>
                                              <th>createdTs</th>
                                              <th>dateCreated</th>
                                              <th>lastUpdated</th>
                                              <th>pdfLink</th>
                                              <th>typeId</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <PaginatedItems itemsPerPage={50} />
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    

                    </div>
);
};
export default PatientConsultationNotesList;